// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MYsW","content":"styles_content__L2aSB"};